import { isEmailValidator } from '@currency-one/validators'
import { pushDataLayer } from 'utils/data-layer-push'
import { FormElements } from '../models/form-elements'
import { signUpForNewsletter, NewsletterResponse } from 'services/newsletter-service'

const getValueFromInput = (inputElement: HTMLInputElement): string | null => {
  return inputElement?.value ?? null
}

const checkRequiredFields = ($formContainer: HTMLDivElement): boolean => {
  const $errorFields = $formContainer.querySelectorAll<HTMLSpanElement>('[data-error-field], [data-error-field-answer]')
  for (const field of $errorFields) {
    if (!field.hasAttribute('hidden')) {
      return false
    }
  }
  return true
}

const valueLength = (value: string | null | false): number => {
  return typeof value === 'string' ? value.length : 0
}

const sendMailToNewsletter = (formElements: FormElements): Promise<NewsletterResponse> => {
  const $email = getValueFromInput(formElements.$emailField) ?? ''
  const $rodoElement = formElements.$formContainerParent.querySelector<HTMLInputElement>('[data-newsletter-rodo]')
  const $rodo = $rodoElement instanceof HTMLInputElement ? $rodoElement.checked : false
  const isFormValid =
    $rodo &&
    isEmailValidator($email) &&
    valueLength($email) > 0 &&
    checkRequiredFields(formElements.$formContainerParent)

  if (isFormValid) {
    return signUpForNewsletter({ email: $email }).then((response) => {
      if (response.response === 'EMAIL_ADDED') {
        pushDataLayer('form_submitted', { form_name: 'Zapis do Newslettera' })
      }
      return response
    })
  }
  return Promise.reject(new Error('Form validation failed or required fields are missing.'))
}

export default sendMailToNewsletter
